import React from 'react';
import './Header.css';
import './HeaderMobile.css';

const Header = ({ content }) => (
  <section className="hero">
    <video className="hero__video" autoPlay muted loop playsInline preload="none" poster={content.poster}>
      <source src={content.video} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <div className="hero__overlay"></div>
    <div className="hero__content">
      <h1>{content.title}</h1>
      <p>{content.subtitle}</p>
      <a href={content.button.href} className="hero__btn">{content.button.label}</a>
    </div>
  </section>
);

export default Header;

